import * as React from "react"
import styled from 'styled-components';
import { Container } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image"

const StyledContainer = styled(Container)`

`

const Greylisting = () => {
    return (
        <StyledContainer>
            <div className="row pt-4">
                <div className="col-sm-6 mw-100">
                    <StaticImage src="../../../images/pricing_co_vs_dropcontact.jpg" alt="Validate email address with Clearout's Email Verifier for accurate results and guaranteed email deliverability" placeholder="blurred" />
                </div>
                <div className="col-sm-6">
                    <p><span className="fw-bolder fs-5">Pricing</span></p>
                    <p>Clearout has a flexible pricing plan including both subscriptions and pay-as-you-go plans starting from $21 for 3000 credits with lifetime validity. Dropcontact offers only subscription plans starting from €34 for 1000 enrichments with 30 days validity.</p>
                </div>
            </div>
        </StyledContainer>
    )
}

export default Greylisting;